module.exports = __webpack_public_path__ + "static/media/DataCentresLogo-white.41fc0019.png";